import React from 'react';
import { Button, Text } from '../../../../design-system';
import { LAST_UPDATED_COLUMN } from '../../../shared-constants';
import { required } from '../../../../helpers/utils';
import DeadlineCell from '../../../../components/DeadlineCell';
import DeleteButton from '../../../../components/DeleteButton';
import StyledLink from '../../../../components/StyledLink';
import DescriptionTooltip from '../../../../components/DescriptionTooltip';

const TYPE_OPTIONS = [
  { value: 'Verbiage', label: 'Verbiage' },
  { value: 'Notes', label: 'Notes' },
];

export const COLUMNS = [
  { Header: 'Title', accessor: 'title' },
  {
    Header: 'Type',
    accessor: 'type',
    Cell: ({ cell: { value } }) => value && value,
  },
  {
    Header: 'Owner',
    accessor: 'creator.name',
    Cell: ({ cell: { value } }) => value && value,
  },
  {
    Header: 'Note',
    accessor: 'note',
    Cell: (props) => <DescriptionTooltip {...props} maxLength={25} />,
  },
  {
    Header: 'Expires',
    accessor: 'expires',
    Cell: DeadlineCell,
  },
  { ...LAST_UPDATED_COLUMN },
  {
    Header: '',
    accessor: 'handleDeleteVerbiage',
    Cell: ({ row: { original }, cell: { value: handleDeleteVerbiage } }) => (
      <Button.Group justifyContent="flex" alignItems="center">
        <StyledLink
          to={`/vault/${original.client_id}/notes-verbiage/${original.id}`}
        >
          <Text id="expand-button">more info</Text>
        </StyledLink>
        {original.canEdit && (
          <DeleteButton onClick={() => handleDeleteVerbiage(original)} />
        )}
      </Button.Group>
    ),
  },
];

export const MODAL_FIELDS = [
  { name: 'title', label: 'Title', validate: required },
  {
    name: 'type',
    label: 'Type',
    type: 'dropdown',
    component: 'select',
    options: TYPE_OPTIONS,
  },
  { name: 'note', label: 'Note', validate: required, multiline: true },
  {
    name: 'expires',
    label: 'Expiration',
    type: 'date',
  },
];

export const SINGLE_ENTITY_FIELDS = [
  {
    label: 'Type',
    name: 'type',
    component: 'select',
    options: TYPE_OPTIONS,
  },
  {
    label: 'Title',
    name: 'title',
  },
  {
    label: 'Note',
    name: 'note',
    multiline: true,
  },
  {
    label: 'Expires',
    name: 'expires',
    type: 'date',
  },
];
